import { Box, Button } from '@mui/material';
import { useNavigate } from 'react-router';
import SidebarSection from './SidebarSection';
import { useIRWorkstation } from '../contexts/IRWorkstationContext';

const VDR_ITEM_STYLES = {
	badgeColor: 'vdr',
	textColor: 'vdr.text',
	hoverBgColor: 'vdr.bg',
};

const IrWorkstationSidebar = () => {
	const navigate = useNavigate();
	const {
		tenant,
		funds,
		fundsLoading,
		fundsError,
		selectedFundId,
		setSelectedFundId,
	} = useIRWorkstation();

	return (
		<Box
			width={200}
			flexShrink={0}
			backgroundColor='background.paper'
			borderRight='0.5px solid'
			borderColor='border.light'
			overflow='auto'
			py='12px'
			display='flex'
			flexDirection='column'
		>
			<Box flex={1}>
				<SidebarSection label='My day'>
					<SidebarSection.Item
						name='Work Queue'
						badge={13}
						badgeColor='red'
					/>
					<SidebarSection.Item name='Alerts' badge={9} badgeColor='red' />
					<SidebarSection.Item
						name='Activity feed'
						badge={18}
						badgeColor='gray'
					/>
				</SidebarSection>

				<SidebarSection label='Coverage'>
					<SidebarSection.Item name='All LPs' badge={22} badgeColor='gray' />
					<SidebarSection.Item name='Tier 1' badge={12} badgeColor='gray' />
					<SidebarSection.Item name='At risk' badge={2} badgeColor='red' />
					<SidebarSection.Item name='Re-up pipeline' />
				</SidebarSection>

				<SidebarSection label='Funds'>
					{fundsLoading ? (
						<SidebarSection.Skeleton count={3} />
					) : fundsError ? (
						<SidebarSection.Item name={fundsError} textColor='error.main' disabled />
					) : funds?.length === 0 ? (
						<SidebarSection.Item name='No funds found' disabled />
					) : (
						<>
							{funds?.map((fund) => (
								<SidebarSection.Item
									key={fund.id}
									name={fund.name}
									badge={fund.has_active_fundraising ? 'Active' : undefined}
									badgeColor='amber'
									active={fund.id === selectedFundId}
									onClick={() => setSelectedFundId(fund.id)}
								/>
							))}
							<SidebarSection.Item
								name='All funds'
								onClick={() =>
									window.open(
										`${tenant?.salesforce_org_url}/lightning/o/AIM__Entity__c/list?filterName=__Recent`,
										'_blank'
									)
								}
							/>
						</>
					)}
				</SidebarSection>

				<SidebarSection
					label='↔ Raise VDR'
					labelColor={VDR_ITEM_STYLES.textColor}
				>
					<SidebarSection.Item
						name='All raises'
						badge={3}
						{...VDR_ITEM_STYLES}
					/>
					<SidebarSection.Item
						name='VDR alerts'
						badge={3}
						{...VDR_ITEM_STYLES}
					/>
					<SidebarSection.Item
						name='Q&A queue'
						badge={2}
						{...VDR_ITEM_STYLES}
					/>
					<SidebarSection.Item name='LP activity' {...VDR_ITEM_STYLES} />
				</SidebarSection>

				<SidebarSection label='Reporting'>
					<SidebarSection.Item name='Q1 cycle' />
					<SidebarSection.Item name='Open Q&A' badge={6} badgeColor='red' />
					<SidebarSection.Item name='SLA tracker' />
				</SidebarSection>
			</Box>

			<Box p='12px'>
				<Button
					variant='filled'
					onClick={() => navigate('/')}
					sx={{
						width: '100%',
						height: '40px',
						backgroundColor: 'background.subtle',
						color: 'status.red.text',
						'&:hover': {
							border: '1px solid',
							borderColor: 'status.red.text',
							backgroundColor: 'status.red.bg',
						},
					}}
				>
					Back to Launchpad
				</Button>
			</Box>
		</Box>
	);
};

export default IrWorkstationSidebar;
